let en = {
  Seal: 'Seal-SC',
  Tech: 'Technology',
  Advantage: 'Advantage',
  Product: 'Product',
  Service: 'Service',
  AboutUs: 'About Us',
  RoadMap: 'Road Map',
  Team: 'Team',
}

let zh = {
  Seal: 'Seal-SC',
  Tech: '技术',
  Advantage: '优势',
  Product: '产品',
  Service: '服务',
  AboutUs: '关于我们',
  RoadMap: '路线图',
  Team: '团队',
}

let name = 'Nav'

export default {
  name,
  en,
  zh
}

